import {
  BreakStyle,
  defineStyles,
  HoverDiv,
  roundCounter,
  useGLTranslation,
  useThemedStyles
} from 'notability-services-common-frontend'
import {TranslationKey} from 'notability-services-common-universal'
import React from 'react'

const styles = defineStyles((theme, font) => {
  const counter: BreakStyle = {
    ...font.body,
    color: theme.core.f2,
    display: 'flex',
    alignItems: 'center',
    marginRight: '16px'
  }

  return {
    counter,
    clickableCounter: {
      ...counter,
      cursor: 'pointer'
    },
    counterImageContainer: {
      display: 'inline',
      float: 'left',
      marginRight: '8px'
    },
    hoverStyle: {
      textDecoration: 'underline'
    }
  }
})

interface CounterDivArgs {
  /** Icon to be displayed along the left */
  iconDiv: React.ReactElement

  /** Number to be displayed for the counter */
  count: number

  /** Translation tag (en.json) for label applied when the count is 1 (default uses same as pluralText) */
  singleText?: TranslationKey

  /** Translation tag (en.json) for label applied when the count is more than 1 */
  pluralText: TranslationKey

  /** CSS classname to apply to the top-level div */
  className?: string

  /** Handler for clicking it. */
  onClick?: (e: React.MouseEvent) => void
}

export default function CounterDiv({
  iconDiv,
  count,
  className,
  pluralText,
  onClick,
  singleText = pluralText
}: CounterDivArgs) {
  const s = useThemedStyles(styles)
  const {t} = useGLTranslation()
  const countStr = t(...roundCounter(count))

  return (
    <HoverDiv
      onClick={onClick}
      conditionalStyle={onClick ? s.hoverStyle : {}}
      style={onClick ? s.clickableCounter : s.counter}
      className={className}
    >
      <div style={s.counterImageContainer}>{iconDiv}</div>
      {t(count === 1 ? singleText : pluralText, {count: countStr})}
    </HoverDiv>
  )
}
